import { forwardRef } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';
import type { TreeItemProps } from '@mui/x-tree-view-pro';

import { ERROR_SUFFIX } from '../../constants';
import { DECOMPOSITION_TREE_TEST_ID } from '../../testIds';
import type { ExtraItemProps } from '../../types';
import { CustomTreeItemStyled, stripExtraItemProps } from './CustomTreeItemStyled';

type ErrorItemProps = TreeItemProps & Pick<ExtraItemProps, 'testIdScope'>;

export const ErrorItem = forwardRef<HTMLLIElement, ErrorItemProps>(function ErrorItem(props, ref) {
  const { testIdScope } = props;
  const treeItemProps = stripExtraItemProps(props);
  const parentId = treeItemProps.itemId.replace(ERROR_SUFFIX, '');

  return (
    <CustomTreeItemStyled
      {...treeItemProps}
      ref={ref}
      data-testid={DECOMPOSITION_TREE_TEST_ID.errorItem(parentId, testIdScope)}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.25 }}>
          <ErrorOutlineIcon color='error' sx={{ fontSize: 16 }} />
          <Typography variant='body2' color='error'>
            Failed to load
          </Typography>
        </Box>
      }
    />
  );
});
